import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import {
  HANDOVER_SESSION_KEY,
  LOGOUT_TIMER_START_KEY,
} from "../generator/utils/refreshLogoutTimer";
import { useDispatch } from "../redux/hooks";
import { setManagementLinks } from "../redux/slices/permsSlice";
import { clearThemeOverride } from "../utils/themeOverride";
import { usePostApi } from "./usePostApi";
/**
 * Custom hook to handle user logout functionality.
 *
 * @returns A function to log out the user.
 */
export const useLogout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { post } = usePostApi();

  const logout = useCallback(async () => {
    dispatch(setManagementLinks(undefined));

    await post({ request: "logout" });
    localStorage.removeItem("authData");
    localStorage.removeItem(LOGOUT_TIMER_START_KEY);
    localStorage.removeItem(HANDOVER_SESSION_KEY);
    clearThemeOverride();
    navigate("/login");
  }, [navigate, post, dispatch]);

  return logout;
};
